/**
 * Client-side access to environment variables injected via <ClientEnv />.
 *
 * IMPORTANT: This should ONLY be used in entry.client.tsx for early SDK initialization.
 * Components should get data from loaders/context, not from this module.
 */

type BloomClientEnv = {
  jdid?: string;
  mixpanelProjectToken?: string;
  nodeEnv?: string;
};

declare global {
  interface Window {
    __BLOOM_CLIENT_ENV__?: BloomClientEnv;
  }
}

export function getClientEnv(): BloomClientEnv {
  if (typeof window === 'undefined') {
    return {};
  }
  return window.__BLOOM_CLIENT_ENV__ ?? {};
}
